// extracted by mini-css-extract-plugin
export default {"wrap":"DataTable_wrap__gqwcY","table":"DataTable_table__kDARA","caption":"DataTable_caption__+Bh2j","empty":"DataTable_empty__v9MZ0"};